import { render } from "./AddRefferal.vue?vue&type=template&id=348c26ac"
import script from "./AddRefferal.vue?vue&type=script&lang=js"
export * from "./AddRefferal.vue?vue&type=script&lang=js"

import "./AddRefferal.vue?vue&type=style&index=0&id=348c26ac&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__